"use client";

import type { ArgsProps } from "antd/es/notification";

import { App } from "antd";

import CloseIcon from "../icons/closeIcon";
import ErrorIcon from "../icons/errorIcon";
import SuccessIcon from "../icons/successIcon";

type NotificationType = {
  type: "success" | "error";
  message: string;
};

export const useNotification = () => {
  const { notification } = App.useApp();

  const openNotification = ({
    type,
    message,
  }: NotificationType) => {
    const key = `notif-${Date.now()}`;
    const commonProps: ArgsProps = {
      key,
      duration: 4,
      placement: "topRight",
      closable: false,
      className:
        type === "error"
          ? "errorBox !rounded-xl !border"
          : "successBox !rounded-xl !border",
      message: null,
      description: (
        <div className="w-full flex flex-col gap-6 justify-center">
          <div className="flex justify-between items-center">
            <div className="flex gap-4 items-center">
              {type === "error" ? (
                <>
                  <ErrorIcon />
                  <span className="text-sm text-regal-error">
                    {message}
                  </span>
                </>
              ) : (
                <>
                  <SuccessIcon />
                  <span className="text-sm text-regal-success">
                    {message}
                  </span>
                </>
              )}
            </div>
            <CloseIcon
              onClick={() => notification.destroy(key)}
              color={type === "error" ? "#EF443C" : "#00BC55"}
            />
          </div>
        </div>
      ),
    };

    notification.open(commonProps);
  };

  return { openNotification };
};
